import Time from '../date/Time';

export default class ChildMinusTime {
    duration() {
        return this.timeRange.start.durationTo(this.timeRange.end);
    }

    static fromData(data) {
        if (!data) {
            return;
        }

        let minusTime = new ChildMinusTime();
        minusTime.id = data.id;
        minusTime.day = data.day;
        minusTime.formattedDay = data.formatted_day;
        minusTime.weekday = data.weekday;
        minusTime.timeRange = {
            start: Time.fromString(data.time_range.start),
            end: Time.fromString(data.time_range.end),
        };
        minusTime.hint = data.hint;

        return minusTime;
    }
}
